import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_walking_female_bmi_to_the_end~1
			funnel: {
				id: 'ob-female-walking-bmi-to-end',
				locale: ['en'],
			},
		},
	},
]

export default config
